<script setup lang="ts">
import { Money } from '@commercetools/platform-sdk';
import { dollars } from '@nuts/auto-delivery-sdk/dist/utils/money';
import dayjs from 'dayjs';
import { computed } from 'vue';

import money from '@/filters/money';
import { Shipment } from '@/utils/cart';
import { calculateDaysBetweenDates, DateString } from '@/utils/dateTime';

const props = withDefaults(
  defineProps<{
    shipment: Shipment;
    showPricing?: boolean;
  }>(),
  {
    showPricing: true,
  },
);

const arrivalDayInfo = computed((): string => {
  let arrivalDay;
  const arrivalDate = dayjs(
    props.shipment.customFields?.shipmentPickupLatestArrivalOn,
    'YYYY-MM-DD',
  );
  const todaysDate = dayjs().format('YYYY-MM-DD') as DateString;
  const daysfromArrival = calculateDaysBetweenDates(
    todaysDate,
    props.shipment.customFields?.shipmentPickupLatestArrivalOn,
  );

  switch (daysfromArrival) {
    case 0:
      arrivalDay = 'Today';
      break;
    case 1:
      arrivalDay = 'Tomorrow';
      break;
    default:
      arrivalDay = arrivalDate.format('dddd');
      break;
  }
  return `${arrivalDay}, ${arrivalDate.format('MMM D')}`;
});
const price = computed((): Money => props.shipment.customFields?.price);
const shippingOption = computed(
  (): string => props.shipment.customFields?.shipmentPickupShippingOption,
);
</script>

<template>
  <div>
    {{ shippingOption }}, {{ arrivalDayInfo }}
    <template v-if="showPricing"> - {{ dollars(price) > 0 ? money(price) : 'FREE' }} </template>
  </div>
</template>
